import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Services } from "./components/Services";
import { About } from "./components/About";
import { Testimonials } from "./components/Testimonials";
import { Newsletter } from "./components/Newsletter";
import { Contact } from "./components/Contact";
import { CollaborationConditions } from "./components/CollaborationConditions";
import { Footer } from "./components/Footer";
/* 
TODO:
- hover for buttons
- pop out for hero items
*/
export default function App() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main>
        <Hero />
        <Services />
        <About />
        <Testimonials />
        <Newsletter />
        <Contact />
        <CollaborationConditions />
      </main>
      <Footer />
    </div>
  );
}